import * as React from 'react';
import Switch from '@mui/material/Switch';
import { Grid, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

interface PropsType {
  handleSwitch?: any;
  switchValue: boolean;
  name: string;
  label: string | React.ReactNode;
  leftLabel?: string | React.ReactNode;
  className?: string;
  tooltip?: string;
}

export default function SwitchCustom(props: PropsType) {
  const { handleSwitch, switchValue, label, leftLabel, className, tooltip, name } = props;
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    handleSwitch(!switchValue);
  };

  return (
    <Grid component="div" container alignItems="center" spacing={1}>
      {leftLabel && <Grid item>{leftLabel}</Grid>}
      <Grid item>
        <Switch
          className={className}
          name={name}
          checked={switchValue}
          onChange={handleSwitch ? handleSwitch : handleChange}
          inputProps={{ 'aria-label': 'controlled' }}
        />
      </Grid>
      <Grid item>{label}</Grid>
      {
        tooltip && 
          <Grid item ml={1} mt={1} pt={1}>
            <Tooltip title={tooltip}><InfoIcon className='info-icon' fontSize='small'/></Tooltip>
          </Grid>
      }
    </Grid>
  );
}